/* src/app/main/pages/documents/terms-of-use/terms-of-use.component.css */
.docs-page {
  box-shadow: 0px 0px 3px #ccc;
}
.docs-page h4,
.docs-page h3 {
  font-size: 19px;
  padding: 10px 0;
}
/*# sourceMappingURL=terms-of-use.component.css.map */
